import {CheckoutContractInformationBody as CheckoutContractInformationBodyRTK} from '@dms/api/shared';

export type CheckoutContractInformationBody = CheckoutContractInformationBodyRTK;
